export const DRUG_ALLERGY_STATUS = {
  allergy: 'allergy',
  denied: 'denied',
  unknown: 'unknown',
}

export const getDrugAllergyStatus = (patient = {}) => {
  if (Number(patient.isAdr) === 1) return DRUG_ALLERGY_STATUS.allergy
  if (Number(patient.isNoAdr) === 1) return DRUG_ALLERGY_STATUS.denied
  return DRUG_ALLERGY_STATUS.unknown
}

export const createDrugAllergyStatusPatch = (status) => ({
  isUnknownAdr: status === DRUG_ALLERGY_STATUS.unknown ? 1 : 0,
  isNoAdr: status === DRUG_ALLERGY_STATUS.denied ? 1 : 0,
  isAdr: status === DRUG_ALLERGY_STATUS.allergy ? 1 : 0,
  ...(status === DRUG_ALLERGY_STATUS.allergy
    ? {}
    : {
        drugAllergy: '',
        drugAllergicReaction: '',
      }),
})

export const normalizePatientDrugAllergy = (patient = {}) => ({
  ...patient,
  ...createDrugAllergyStatusPatch(getDrugAllergyStatus(patient)),
})
